<template>
	<div class="information-container">
		<!-- Divider -->
		<divider-generic :dividerSize="'medium'" :applyBorder="!getMobileAppState" :icon="'qr-code'" :title="t('userArea.profile.qrCodeTitle')"/>
		<!-- qr code message -->
		<div class="info-message">{{t('userArea.profile.qrCodeMessage')}}</div>
		<!-- Button to open QR Code detail -->
		<button-tertiary
		class="info-button"
		icon="qr-code"
		buttonSize="small"
		:label="t('userArea.profile.qrCodeBtn')"
		@clicked="showDetails = true"/>
	</div>
	<!-- QR Code detail -->
	<qr-code-details v-if="showDetails" :isMobile="getMobileAppState" @hideMe="showDetails = false"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
import QrCodeDetails from '@/components/features/userArea/profile/QRCodeDetails'

/* Vue */
import { ref } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getMobileAppState } = mapGetters()

const showDetails = ref(false)
</script>

<style lang="scss" scoped>
.information-container {
	width: 100%;
    max-width: 508px;
    margin-bottom: 24px;

	.info-message {
		margin: 24px 0 16px 0;

		color: var(--secondary-dark-3);
		font-size: 14px;
		font-weight: 400;
		line-height: 18px;
		word-wrap: break-word
	}

	.info-button {
		max-width: 193px;
        height: 48px;
	}
}
</style>
